import { RouteComponentProps, generatePath } from 'react-router';
import { ReactNode } from 'react';
import {
    jobOfferRouteRenderer,
    jobOfferApplicationRouteRenderer,
    jobOfferApplicationSentRouteRenderer
} from './components/jobOffers/routes';

export const BASE_URL = process.env.REACT_APP_BASE_URL || '';

enum RoutePathEnum {
    JOB_OFFER_APPLICATION = '/:id/apply',
    JOB_OFFER_APPLICATION_SENT = '/:id/sent',
    JOB_OFFER = '/:id'
}

export class RoutePath {
    static jobOffer(id: string): string {
        return generatePath(RoutePathEnum.JOB_OFFER, { id });
    }

    static jobOfferApplication(id: string): string {
        return generatePath(RoutePathEnum.JOB_OFFER_APPLICATION, { id });
    }

    static jobOfferApplicationSent(id: string): string {
        return generatePath(RoutePathEnum.JOB_OFFER_APPLICATION_SENT, { id });
    }
}

export interface RouteConfig {
    path: string;
    renderer: (props: RouteComponentProps<any>) => ReactNode;
    isExact: boolean;
}

export const appRoutes: RouteConfig[] = [
    {
        path: RoutePathEnum.JOB_OFFER_APPLICATION_SENT,
        renderer: jobOfferApplicationSentRouteRenderer,
        isExact: true
    },
    {
        path: RoutePathEnum.JOB_OFFER_APPLICATION,
        renderer: jobOfferApplicationRouteRenderer,
        isExact: true
    },
    {
        path: RoutePathEnum.JOB_OFFER,
        renderer: jobOfferRouteRenderer,
        isExact: true
    }
];
